import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const SmsTemplates = (props) => {
  const token = window.localStorage.getItem('auth-token')

  const { operator: { id, locales } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index sms-templates' />
    )
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index sms-templates'>
      {/* eslint-disable-next-line */}
    <h1></h1>

      <cl-templates
        apihost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/sms-templates`}
        operatorid={id}
        token={token}
        locales={locales}
      />
    </div>
  )
}

export default SmsTemplates
